import { SOCKET_ON_MESSAGE } from './constants'

export function onMessage(type, content) {
    return {
        type: SOCKET_ON_MESSAGE,
        data: {
            type,
            content,
        },
    }
}
